import router from '@/router';

const OCRoutes = [
  {
    path: 'user/created_phases',
    name: 'UserCreatedPhase',
    component: {
      name: 'UserCreatedPhase',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'created_phase',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserCreatedPhaseIndex',
        component: () => import('../views/user/CreatedPhasesUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserCreatedPhaseShow',
        component: () => import('../views/user/CreatedPhaseUserShow.vue'),
        meta: {
          backRoute: {
            name: 'UserCreatedPhaseIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserCreatedPhaseDetails',
            component: () => import('../views/user/CreatedPhaseUserDetails.vue'),
            meta: {
              backRoute: { name: 'UserCreatedPhaseIndex' },
            },
          },
          {
            path: 'edit',
            name: 'UserCreatedPhaseEdit',
            component: () => import('../views/user/CreatedPhaseUserInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'UserCreatedPhaseDetails' },
            },
          },
        ],
      },
    ]
  },
  {
    path: 'admin/created_phases',
    name: 'AdminCreatedPhase',
    component: {
      name: 'AdminCreatedPhase',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'created_phase',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminCreatedPhaseIndex',
        component: () => import('../views/admin/CreatedPhasesAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminCreatedPhaseShow',
        component: () => import('../views/admin/CreatedPhaseAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminCreatedPhaseIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminCreatedPhaseDetails',
            component: () => import('../views/admin/CreatedPhaseAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminCreatedPhaseIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminCreatedPhaseEdit',
            component: () => import('../views/admin/CreatedPhaseAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminCreatedPhaseDetails' },
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));